<template>
  <section>
    <div v-if="order.book_more_hours.length > 0">
      <hr>
      <div v-for="(orderAdditionalHours, index) in order.book_more_hours">
        <div class="d-flex">
          <div class="flex-fill">
            {{ $t('message.my_reservations.additional_hours') }} #{{ orderAdditionalHours.id }}
          </div>
          <div class="flex-fill text-right">
            {{ orderAdditionalHours.work_hour }} {{ $tc('message.hour', orderAdditionalHours.work_hour) }}
          </div>
        </div>
        <div class="d-flex mt-1">
          <div class="flex-fill">
            {{ $t('message.my_reservations.sent_request_at') }}
          </div>
          <div class="flex-fill text-right text-secondary">
            {{ orderAdditionalHours.created_at | prettyDate }}
          </div>
        </div>
        <div class="d-flex mt-1">
          <div class="flex-fill">
            {{ $t('message.my_reservations.status') }}
          </div>
          <div class="flex-fill text-right">
            <span :class="getOrderAdditionalHoursStatus(orderAdditionalHours).textColor">
              {{ getOrderAdditionalHoursStatus(orderAdditionalHours).status }}
            </span>
          </div>
        </div>
        <!-- Professional declined request with bank transfer or promptpay -->
        <div class="pt-2"
             v-if="orderAdditionalHours.is_declined && (orderAdditionalHours.payment_method === 'bank_transfer' || orderAdditionalHours.payment_method === 'promptpay')">
          <span class="bullet-notification">
            <i class="fas fa-circle"></i>
          </span>
          <span class="text-secondary">
            {{ $t('message.my_reservations.request_declined_remark') }}
          </span>
        </div>

        <!-- Promptpay payment reload -->
        <div class="pt-3"
             v-if="!orderAdditionalHours.paid_status && !orderAdditionalHours.cancel && orderAdditionalHours.payment_method === 'promptpay'">
          <div class="pb-3 text-remark">
            {{ $t('message.my_reservations.qr_payment_unpaid_remark') }}
          </div>
          <router-link class="btn btn-outline-info btn-block" :to="`/reservation/${order.id}/additional-hours?id=${orderAdditionalHours.id}`">
            {{ $t('message.button.qr_payment') }}
          </router-link>
        </div>

        <!-- Payment failure -->
        <div class="pt-3 -status-alert text-small" v-if="orderAdditionalHours.has_payment_failure && !orderAdditionalHours.cancel">
          <i class="fas fa-exclamation-triangle"></i>  {{ $t('message.my_reservations.payment_failed_remark', { remark: orderAdditionalHours.payment_failure_remark }) }}
        </div>

        <!-- User accept or decline request from professional -->
        <div class="row no-gutters pt-3"
             v-if="orderAdditionalHours.sender_type === 'professional' && !orderAdditionalHours.status && !orderAdditionalHours.payment_method">
          <div class="col-6 pr-1">
            <button class="btn btn-outline-info btn-block"
                    @click="cancelOrderAdditionalHours(orderAdditionalHours.id)">
              {{ $t('message.button.cancel') }}
            </button>
          </div>
          <div class="col-6 pl-1">
            <router-link class="btn btn-info btn-block" :to="`/reservation/${order.id}/additional-hours?id=${orderAdditionalHours.id}`">
              {{ $t('message.button.make_a_payment') }}
            </router-link>
          </div>
        </div>

        <!-- User cancel own request with credit card payment -->
        <div class="pt-3"
             v-if="orderAdditionalHours.sender_type === 'user' && orderAdditionalHours.status === 0 &amp;&amp; orderAdditionalHours.payment_method === 'credit_card'">
          <button class="btn btn-outline-info btn-block"
                  @click="cancelOrderAdditionalHours(orderAdditionalHours.id)">
            {{ $t('message.button.cancel') }}
          </button>
        </div>
        <hr v-if="((index + 1) < order.book_more_hours.length) || $route.matched[0].path === '/chat-booking'">
      </div>
    </div>
    <!-- Book additional hours -->
    <book-additional-hours-modal ref="bookAdditionalHoursModal" :parentServiceId="parentServiceId"/>
  </section>
</template>

<script>
  import { mapActions, mapGetters } from 'vuex'
  import BookAdditionalHoursModal from './BookAdditionalHoursModal'
  import axios from 'axios'
  import orderHelpers from '../../../helpers/orderHelpers'

  export default {
    props: {
      order: Object
    },
    components: {
      BookAdditionalHoursModal
    },
    data () {
      return {
        parentServiceId: null,
        textStatusColor: []
      }
    },
    computed: {
      ...mapGetters({
        globalState: 'globalVal/getState'
      })
    },
    methods: {
      ...mapActions('orderDetail', ['loadOrderDetail']),
      getOrderAdditionalHoursStatus (orderAdditionalHours) {
        return orderHelpers.getOrderAdditionalHoursStatus(orderAdditionalHours)
      },
      openBookAdditionalHoursModal (orderAdditionalHoursId) {
        this.$refs.bookAdditionalHoursModal.setOrderAdditionalHoursId(orderAdditionalHoursId)
        this.$refs.bookAdditionalHoursModal.showBookAdditionalHoursModal(true)
      },
      cancelOrderAdditionalHours (orderAdditionalHoursId) {
        this.$swal({
          title: this.$i18n.t('message.confirm.title'),
          text: this.$i18n.t('message.confirm.cancel_addition_hour'),
          type: 'warning',
          showCancelButton: true,
          confirmButtonColor: '#3085d6',
          cancelButtonColor: '#9E9E9E',
          reverseButtons: true,
          confirmButtonText: this.$i18n.t('message.confirm.yes'),
          cancelButtonText: this.$i18n.t('message.confirm.no')
        }).then(async () => {
          const url = `/order-additional-hours/${orderAdditionalHoursId}/cancel`
          const {data} = await axios.post(url)
          if (data.error) {
            this.$swal({text: data.message, type: 'error'})
          }
          // Load new order detail
          await this.loadOrderDetail(this.order.id)
        })
      },
      getParentServiceId () {
        this.parentServiceId = this.order.service_id
        if (this.globalState.services[this.order.service_id].parent_id > 0) {
          this.parentServiceId = this.globalState.services[this.order.service_id].parent_id
        }
      }
    },
    mounted () {
      this.getParentServiceId()
    }
  }
</script>



// WEBPACK FOOTER //
// src/components/order/components/OrderAdditionalHours.vue